import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { SCHOOL_NAV } from "./SchoolDashboard";
import api from "@/lib/api";

export default function PurchaseOrders() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/purchase-orders").then((r) => setItems(r.data)); }, []);
  const invColor = (s) => s === "paid" ? "bg-emerald-50 text-brand-greenDark"
    : s === "submitted" ? "bg-blue-50 text-brand-blue"
    : "bg-slate-100 text-slate-500";
  return (
    <DashboardLayout nav={SCHOOL_NAV} title="Purchase Orders">
      <div className="sl-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-4 py-3">PO Number</th>
                <th className="text-left px-4 py-3">Supplier</th>
                <th className="text-left px-4 py-3">Category</th>
                <th className="text-right px-4 py-3">Amount</th>
                <th className="text-left px-4 py-3">Status</th>
                <th className="text-left px-4 py-3">Delivery</th>
                <th className="text-left px-4 py-3">Invoice</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-t border-slate-100" data-testid={`po-${p.id}`}>
                  <td className="px-4 py-3 font-mono text-xs font-semibold text-slate-800">{p.po_number}</td>
                  <td className="px-4 py-3">
                    <div className="flex flex-col gap-0.5">
                      <span className="font-mono text-xs text-slate-800">{p.supplier_ref}</span>
                      <span className={`inline-flex text-[10px] w-fit px-2 py-0.5 rounded-full ${p.supplier_tier === 'Preferred Supplier' ? 'bg-emerald-50 text-brand-greenDark' : 'bg-blue-50 text-brand-blue'}`}>{p.supplier_tier || 'Approved Supplier'}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-slate-600">{p.category}</td>
                  <td className="px-4 py-3 text-right font-semibold">₹{Number(p.total).toLocaleString('en-IN')}</td>
                  <td className="px-4 py-3"><span className="text-xs px-2 py-1 rounded-full bg-blue-50 text-brand-blue">{p.status}</span></td>
                  <td className="px-4 py-3"><span className={`text-xs px-2 py-1 rounded-full ${p.delivery_status === 'delivered' ? 'bg-emerald-50 text-brand-greenDark' : p.delivery_status === 'shipped' ? 'bg-amber-50 text-amber-700' : 'bg-slate-100 text-slate-500'}`}>{p.delivery_status}</span></td>
                  <td className="px-4 py-3">
                    {p.customer_invoice_number ? (
                      <div className="flex flex-col gap-0.5">
                        <span className="font-mono text-[11px] text-slate-500">{p.customer_invoice_number}</span>
                        <span className="inline-flex text-xs px-2 py-0.5 rounded-full bg-emerald-50 text-brand-greenDark w-fit">₹{Number(p.customer_invoice_amount).toLocaleString('en-IN')}</span>
                      </div>
                    ) : <span className="text-xs text-slate-400">—</span>}
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={7} className="text-center text-slate-500 py-10">No purchase orders yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
